import Vue from 'vue'
import VueFeather from 'vue-feather'

Vue.use(VueFeather)